/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// ================= Products Data Loader =================
	const loadProductsData = (callback) => {
		// console.log("loadProductsData");
		
		// 現在のURLから言語とブランドを判定
		function getCurrentContext() {
			var path = window.location.pathname;
			var language = 'ja'; // デフォルト
			var brand = '';

			if (path.includes('/ja/')) {
				language = 'ja';
			} else if (path.includes('/en/')) {
				language = 'en';
			}

			if (path.includes('/orientstar/')) {
				brand = 'orientstar';
			} else if (path.includes('/orient/')) {
				brand = 'orient';
			}

			return { language: language, brand: brand };
		}

		const context = getCurrentContext();

		// 言語に応じてajaxパスのプレフィックスを決定
		const ajaxPrefix = context.language === 'en' ? '/ajax/en/' : '/ajax/';

		// コレクション別のJSONパスマッピング
		const collectionPaths = {
			orientstar: {
				classic: ajaxPrefix + 'os_classic/product_list.json',
				contemporary: ajaxPrefix + 'os_contemporary/product_list.json',
				sports: ajaxPrefix + 'os_sports/product_list.json'
			},
			orient: {
				classic: ajaxPrefix + 'or_classic/product_list.json',
				contemporary: ajaxPrefix + 'or_contemporary/product_list.json',
				sports: ajaxPrefix + 'or_sports/product_list.json',
				revival: ajaxPrefix + 'or_revival/product_list.json',
				io: ajaxPrefix + 'or_io/product_list.json'
			}
		};
		
		if (!context.brand || !collectionPaths[context.brand]) {
			// console.log('ブランドが検出されませんでした');
			// ブランドページでない場合もスライダー初期化を実行
			if (callback) callback();
			return;
		}

		const collections = collectionPaths[context.brand];
		const allProductsData = {}; // コレクション別の商品データを保存
		
		// コレクションの順序を定義
		const collectionOrder = {
			orientstar: ['classic', 'contemporary', 'sports'],
			orient: ['classic', 'contemporary', 'sports', 'revival', 'io']
		};
		
		const orderedCollections = collectionOrder[context.brand] || Object.keys(collections);
		
		// 各コレクションのデータを取得
		let fetchPromises = orderedCollections.map(function(collectionKey) {
			const jsonPath = collections[collectionKey];
			
			return fetch(jsonPath)
				.then(function(response) {
					if (!response.ok) {
						throw new Error('HTTP error! status: ' + response.status);
					}
					return response.json();
				})
				.then(function(data) {
					// console.log('=== ' + context.brand.toUpperCase() + ' - ' + collectionKey.toUpperCase() + ' ===');
					// console.log('JSON Path:', jsonPath);
					// console.log('Products Data:', data);
					
					// rt_bn_product_list を確認
					if (data.rt_bn_product_list && Array.isArray(data.rt_bn_product_list)) {
						// console.log('商品数:', data.rt_bn_product_list.length);
						allProductsData[collectionKey] = data.rt_bn_product_list;
					}
					// console.log('---');
				})
				.catch(function(error) {
					// console.error('Error loading ' + collectionKey + ':', error);
				});
		});

		// すべてのデータ取得完了後にDOM生成、その後コールバック実行
		Promise.all(fetchPromises).then(function() {
			// console.log('全コレクションデータ取得完了:', allProductsData);
			generateProductSlides(allProductsData, context);
			// スライド生成完了後にコールバック実行（Swiper初期化など）
			if (callback) {
				setTimeout(callback, 100); // DOM更新を待つため少し遅延
			}
		});
	};

	// ================= Products Slides DOM Generator =================
	const generateProductSlides = (productsData, context) => {
		const sliderContainer = document.querySelector('.js-products-slider');
		if (!sliderContainer) {
			// console.log('スライダーコンテナが見つかりません');
			return;
		}

		const swiperWrapper = sliderContainer.querySelector('.swiper-wrapper');
		if (!swiperWrapper) {
			// console.log('swiper-wrapperが見つかりません');
			return;
		}

		// 既存のスライドをクリア（必要に応じて）
		// swiperWrapper.innerHTML = '';

		// 全スライドに通し番号を付与するためのカウンター
		let globalSlideIndex = 0;

		// コレクションの順序を定義（loadProductsDataと同じ順序）
		const collectionOrder = {
			orientstar: ['classic', 'contemporary', 'sports'],
			orient: ['classic', 'contemporary', 'sports', 'revival', 'io']
		};
		
		const orderedCollections = collectionOrder[context.brand] || Object.keys(productsData);

		// 各コレクションの商品からスライドを生成
		orderedCollections.forEach(function(collectionKey) {
			const products = productsData[collectionKey];
			
			if (!products || products.length === 0) return;

			// console.log('生成中: ' + collectionKey + ' (' + products.length + '件)');

			products.forEach(function(product) {
				// スライドHTML生成
				const slide = document.createElement('div');
				slide.className = 'swiper-slide';
				slide.setAttribute('data-product-name', product.cf_p_name || '');
				slide.setAttribute('data-petname', product.cf_p_petname?.cf_pn_collection_name_en || '');
				
				// data-detail-url を生成
				var detailUrl = '';
				
				// デバッグ情報を出力
				console.log('=== detailURL生成デバッグ ===');
				console.log(product)
				console.log('product.cf_p_name:', product.cf_p_name);
				console.log('product.cf_p_part_no:', product.cf_p_part_no);
				console.log('product.cf_p_petname:', product.cf_p_petname);
				if (product.cf_p_petname) {
					console.log('  cf_pn_collection_url:', product.cf_p_petname.cf_pn_collection_url);
					console.log('  cf_pn_url:', product.cf_p_petname.cf_pn_url);
					console.log('  cf_pn_collection_name_en:', product.cf_p_petname.cf_pn_collection_name_en);
				}
				
				// 条件を緩和してURLを生成
				if (product.cf_p_petname && product.cf_p_part_no) {
					var collectionUrl = product.cf_p_petname.cf_pn_collection_url || 'unknown';
					var productUrl = product.cf_p_petname.cf_pn_url || product.cf_p_part_no.toLowerCase();
					detailUrl = '/' + context.language + '/' + context.brand + '/collection/' + collectionUrl + '/' + productUrl + '/' + product.cf_p_part_no + '/';
					console.log('生成されたdetailUrl:', detailUrl);
				} else {
					console.log('detailURL生成に必要な情報が不足しています');
				}
				
				slide.setAttribute('data-detail-url', detailUrl);
				
				slide.setAttribute('data-buy-url', product.cf_p_online_purchase_url_jp || '');
				slide.setAttribute('data-product-img', product.cf_p_new_model_img || '');
				slide.setAttribute('data-slide-index', globalSlideIndex); // 全体通し番号を付与
				
				// 限定フラグをチェック（cf_p_limitedに値があれば限定）
				var isLimited = product.cf_p_limited && product.cf_p_limited !== '';
				if (isLimited) {
					slide.setAttribute('data-limited', 'true');
				}

				slide.innerHTML = 
					'<div class="p-products-item">' +
						'<div class="p-products-thumb">' +
							'<img src="' + (product.cf_p_new_model_img || '') + '" ' +
							'alt="' + (product.cf_p_new_model_img_alt || product.cf_p_name || '') + '" ' +
							'width="334" height="466" loading="lazy" class="p-products-img">' +
						'</div>' +
					'</div>';

				swiperWrapper.appendChild(slide);
				globalSlideIndex++; // インデックスを増やす
			});
		});

		// console.log('スライド生成完了: 合計' + swiperWrapper.children.length + '枚');
		
		// タブの有効/無効を設定
		updateTabsAvailability(swiperWrapper);
	};

	// ================= Update Tabs Availability =================
	const updateTabsAvailability = (swiperWrapper) => {
		// 各カテゴリーのスライド存在チェック
		const categorySlides = {};
		const slides = swiperWrapper.querySelectorAll('.swiper-slide:not([data-clone])');
		
		slides.forEach(function(slide) {
			var petname = slide.getAttribute('data-petname');
			if (petname) {
				var category = petname.toLowerCase();
				if (!categorySlides[category]) {
					categorySlides[category] = 0;
				}
				categorySlides[category]++;
			}
		});
		
		// console.log('カテゴリー別スライド数:', categorySlides);
		
		// タブの有効/無効を設定
		var tabs = document.querySelectorAll('.p-products-tab');
		var firstAvailableTab = null; // リストがある最初のタブを記録
		
		tabs.forEach(function(tab) {
			var tabValue = tab.getAttribute('data-products-tab');
			if (tabValue) {
				var category = tabValue.toLowerCase();
				var hasSlides = categorySlides[category] && categorySlides[category] > 0;
				
				if (!hasSlides) {
					// スライドがない場合は無効化
					tab.classList.add('is-disabled');
					tab.setAttribute('aria-disabled', 'true');
					tab.setAttribute('tabindex', '-1');
					// 既存のis-activeクラスを削除
					tab.classList.remove('is-active');
					tab.setAttribute('aria-selected', 'false');
					// console.log('タブ "' + tabValue + '" を無効化（スライド数: 0）');
				} else {
					// スライドがある場合は有効化
					tab.classList.remove('is-disabled');
					tab.removeAttribute('aria-disabled');
					
					// 最初の有効なタブを記録
					if (!firstAvailableTab) {
						firstAvailableTab = tab;
					}
					
					// console.log('タブ "' + tabValue + '" を有効化（スライド数: ' + categorySlides[category] + '）');
				}
			}
		});
		
		// リストがある最初のタブにis-activeクラスを付与
		if (firstAvailableTab) {
			// 全タブからis-activeを削除
			tabs.forEach(function(tab) {
				tab.classList.remove('is-active');
				tab.setAttribute('aria-selected', 'false');
				tab.setAttribute('tabindex', '-1');
			});
			
			// 最初の有効なタブにis-activeを付与
			firstAvailableTab.classList.add('is-active');
			firstAvailableTab.setAttribute('aria-selected', 'true');
			firstAvailableTab.setAttribute('tabindex', '0');
			// console.log('タブ "' + firstAvailableTab.getAttribute('data-products-tab') + '" を初期アクティブに設定');
		}
	};

	// ================= Products Slider =================
	const initProductsSlider = () => {
		(function () {
			// Product Slider (simple loop, 5 constant slides, no scaling)
			var root = document.querySelector('.p-products-swiper');
			if (!root) return;
			var wrapper = root.querySelector('.swiper-wrapper');
			var baseSlides = Array.from(wrapper.children).filter(function (el) { return el.classList.contains('swiper-slide'); });
			if (baseSlides.length === 0) return;
			var ORIGINAL_COUNT = baseSlides.length; // 実スライド枚数（インジケータ用）

			// 元スライドへ通し番号 data-orig-index を付与
			baseSlides.forEach(function (slide, i) {
				slide.setAttribute('data-orig-index', i);
			});

			var capRoot = document.querySelector('.p-products-caption');
			var capName = capRoot.querySelector('.p-products-caption-name');
			var capDetail = capRoot.querySelector('[data-products-detail]');
			var capBuy = capRoot.querySelector('[data-products-buy]');
			var capLimited = capRoot.querySelector('.p-products-caption-limited');

			// クローンを含む activeIndex でも data-* は複製済みなのでそのまま参照でOK。
			function updateCaption(sw) {
				var slide = sw.slides[sw.activeIndex];
				if (!slide) return;
				capName.textContent = slide.getAttribute('data-product-name') || '';
				capDetail.setAttribute('href', slide.getAttribute('data-detail-url') || '#');
				
				var buyUrl = slide.getAttribute('data-buy-url') || '';
				if (buyUrl) {
					capBuy.setAttribute('href', buyUrl);
					capBuy.style.display = '';
				} else {
					capBuy.style.display = 'none';
				}
				
				// 限定フラグの表示/非表示
				if (capLimited) {
					var isLimited = slide.getAttribute('data-limited') === 'true';
					if (isLimited) {
						capLimited.classList.remove('di_none');
					} else {
						capLimited.classList.add('di_none');
					}
				}
			}

			// スライド変更時にタブを自動更新する関数
			function updateActiveTabBySlide(sw) {
				var activeSlide = sw.slides[sw.activeIndex];
				if (!activeSlide) return;
				
				var petname = activeSlide.getAttribute('data-petname');
				if (!petname) return;
				
				var category = petname.toLowerCase(); // classic, contemporary, sports など
				
				// 対応するタブボタンを探す
				var tablist = document.querySelector('.p-products-tabs');
				if (!tablist) return;
				
				var tabs = tablist.querySelectorAll('.p-products-tab');
				var targetTab = null;
				
				tabs.forEach(function(tab) {
					var tabValue = tab.getAttribute('data-products-tab');
					if (tabValue && tabValue.toLowerCase() === category) {
						targetTab = tab;
					}
				});
				
				if (!targetTab) return;
				
				// 無効化されているタブはアクティブにしない
				if (targetTab.classList.contains('is-disabled') || targetTab.getAttribute('aria-disabled') === 'true') {
					return;
				}
				
				// すべてのタブを非アクティブにして、対象タブをアクティブに
				tabs.forEach(function(tab) {
					var isActive = (tab === targetTab);
					tab.classList.toggle('is-active', isActive);
					tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
					tab.tabIndex = isActive ? 0 : -1;
				});
				
				// リンクも更新
				var productsLink = document.querySelector('.js-products-link a');
				var productsLinkSpan = productsLink ? productsLink.querySelector('span') : null;
				if (productsLink && productsLinkSpan) {
					var tabText = targetTab.textContent.trim();
					var tabValue = targetTab.getAttribute('data-products-tab');
					var language = window.location.pathname.includes('/en/') ? 'en' : 'ja';
					
					// 現在のURLからブランドを判定
					var path = window.location.pathname;
					var brand = 'orient'; // デフォルト
					if (path.includes('/orientstar/')) {
						brand = 'orientstar';
					} else if (path.includes('/orient/')) {
						brand = 'orient';
					}
					
					productsLinkSpan.textContent = tabText;
					var newHref = '/' + language + '/' + brand + '/collection/' + tabValue.toLowerCase() + '/';
					productsLink.setAttribute('href', newHref);
				}
			}

			var prodSwiper = new Swiper('.p-products-swiper', {
				loop: true,
				loopedSlides: ORIGINAL_COUNT,
				loopAdditionalSlides: 0,
				slidesPerView: ORIGINAL_COUNT,
				slidesPerGroup: 1,
				spaceBetween: 32, // アイテム間隔を幅げる（16pxから32pxへ）
				speed: 1000,
				centeredSlides: true,
				watchSlidesProgress: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
					reverseDirection: false
				},
				// タッチ挙動安定化 (B案: 重く=ひとつずつ意図的な操作にする)
				shortSwipes: true,
				longSwipes: true,
				longSwipesRatio: 0.15,
				followFinger: true,
				touchRatio: 0.5, // 指の移動に対するスライド移動率を低めに
				threshold: 10,   // 最低移動距離
				resistanceRatio: 0.6,
				allowTouchMove: true,
				// freeMode/momentum を使わない（ジャンプ感を排除）
				watchOverflow: true,
				a11y: { enabled: true },
				pagination: {
					el: '.p-products-pagination',
					clickable: true,
					renderBullet: function (index, className) {
						if (index >= ORIGINAL_COUNT) return '';
						return '<button type="button" class="products-progress-bullet ' + className + '" data-bullet-index="' + index + '" aria-label="' + (index + 1) + ' / ' + ORIGINAL_COUNT + ' 製品">' +
							'<svg class="products-progress-svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
							'<circle cx="7" cy="7" r="6.5" class="products-progress-bg" />' +
							'<circle cx="7" cy="7" r="6.5" class="products-progress-fill" />' +
							'</svg>' +
							'<div class="products-progress-dot" aria-hidden="true"></div>' +
							'</button>';
					}
				},
				breakpoints: {
					769: { slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 100, centeredSlides: true }, // デスクトップで間隔広げる
					480: { slidesPerView: 2.2, slidesPerGroup: 1, spaceBetween: 20, centeredSlides: true }, // タブレットサイズ追加
					0: { slidesPerView: 1.8, slidesPerGroup: 1, spaceBetween: 16, centeredSlides: true } // スマホでも少し間隔をつける
				},
				on: {
					init: function (sw) {
						updateCaption(sw);
						syncPagination(sw);
						updateActiveTabBySlide(sw); // 初期化時にもタブを更新
						// 初期化時にもSVGプログレスを設定
						setTimeout(function () {
							var activeSlide = sw.slides[sw.activeIndex];
							if (activeSlide) {
								var orig = activeSlide.getAttribute('data-orig-index');
								if (orig !== null) {
									updateProductsProgressPagination(parseInt(orig));
								}
							}
						}, 100);
					},
					slideChange: function (sw) { 
						updateCaption(sw); 
						syncPagination(sw); 
						updateActiveTabBySlide(sw); // スライド変更時にタブを自動更新
					}
				}
			});
			// グローバルへ公開 (後段のスケール制御用)
			window.__prodSwiper = prodSwiper;

			// 元 index に基づき pagination を同期
			function syncPagination(sw) {
				var active = sw.slides[sw.activeIndex];
				if (!active) return;
				var orig = active.getAttribute('data-orig-index');
				if (orig == null) return;
				var bulletsWrapper = sw.pagination && sw.pagination.el ? sw.pagination.el : null;
				if (!bulletsWrapper) return;
				var bullets = bulletsWrapper.querySelectorAll('[data-bullet-index]');
				bullets.forEach(function (b) {
					if (b.getAttribute('data-bullet-index') === orig) {
						b.classList.add('swiper-pagination-bullet-active');
						b.setAttribute('aria-current', 'true');
					} else {
						b.classList.remove('swiper-pagination-bullet-active');
						b.removeAttribute('aria-current');
					}
				});
				// SVGプログレスアニメーション更新
				updateProductsProgressPagination(parseInt(orig));
			}

			// 商品スライダー用SVGプログレスアニメーション更新関数
			function updateProductsProgressPagination(activeIndex) {
				const bullets = document.querySelectorAll('.p-products-pagination .products-progress-bullet');
				bullets.forEach(function (bullet, index) {
					const fill = bullet.querySelector('.products-progress-fill');
					if (!fill) return;

					const isActive = index === activeIndex;
					if (isActive) {
						// 4秒のアニメーション（商品スライダーの完全サイクル: delay 3s + speed 1s）
						fill.style.animation = 'productsProgressGauge 4s linear forwards';
						fill.setAttribute('aria-hidden', 'false');
						bullet.setAttribute('aria-current', 'true');
					} else {
						// 周長更新 (r=6.5) に伴うリセット値調整
						fill.style.strokeDashoffset = '40.84';
						fill.style.animation = 'none';
						bullet.removeAttribute('aria-current');
					}
				});
			}

			// フォーカスで該当スライドへ（キーボード操作補助）
			prodSwiper.on('init', function (sw) {
				sw.slides.forEach(function (slide) {
					slide.setAttribute('tabindex', '0');
					slide.addEventListener('focus', function () {
						var idx = Array.prototype.indexOf.call(sw.slides, slide);
						if (idx > -1) sw.slideTo(idx);
						// フォーカス移動でもインジケータ同期
						syncPagination(sw);
					});
				});
				// bullet クリック時にもリアルインデックスへ移動後再同期
				var bulletsWrapper = sw.pagination && sw.pagination.el ? sw.pagination.el : null;
				if (bulletsWrapper) {
					bulletsWrapper.addEventListener('click', function (e) {
						var target = e.target.closest('[data-bullet-index]');
						if (!target) return;
						// Swiper の click ハンドラ後に強制同期 (微小遅延で activeIndex 反映済み保証)
						setTimeout(function () { syncPagination(sw); }, 0);
					});
				}

				// SVGプログレスボタン個別クリックイベント
				setTimeout(function () {
					var progressBullets = document.querySelectorAll('.p-products-pagination .products-progress-bullet');
					progressBullets.forEach(function (bullet, index) {
						bullet.addEventListener('click', function (e) {
							e.preventDefault();
							var bulletIndex = parseInt(bullet.getAttribute('data-bullet-index'));
							if (!isNaN(bulletIndex)) {
								// 対応するオリジナルインデックスのスライドを見つける
								var targetSlide = null;
								var targetSlideIndex = -1;
								sw.slides.forEach(function (slide, i) {
									var origIndex = slide.getAttribute('data-orig-index');
									if (origIndex !== null && parseInt(origIndex) === bulletIndex) {
										targetSlide = slide;
										targetSlideIndex = i;
									}
								});
								if (targetSlideIndex !== -1) {
									sw.slideTo(targetSlideIndex);
									updateCaption(sw);
									updateProductsProgressPagination(bulletIndex);
								}
							}
						});
					});
				}, 200);
			});
		})();
	};

	// ================= Contents Slider =================
	const initContentsSlider = () => {
		(function () {
			var root = document.querySelector('.p-contents-swiper');
			if (!root) return;
			
			// スライド数をチェック
			var slides = root.querySelectorAll('.swiper-slide');
			if (slides.length <= 1) {
				// console.log('コンテンツスライドが1つ以下のためスライダーを無効化');
				// スライドが1つの場合、そのスライドに.mAutoクラスを付与
				if (slides.length === 1) {
					slides[0].classList.add('mAuto');
				}
				return;
			}
			
			var contentsSwiper = new Swiper('.p-contents-swiper', {
				loop: true,
				centeredSlides: true,
				slidesPerView: 'auto',
				spaceBetween: 20,
				speed: 1000,
				watchSlidesProgress: true,
				autoplay: {
					delay: 4500,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
					reverseDirection: false
				},
				a11y: { enabled: true },
				pagination: {
					el: '.p-contents-pagination',
					clickable: true,
					renderBullet: function (index, className) {
						var total = 5; // 固定5枚
						return '<button type="button" class="contents-progress-bullet ' + className + '" data-contents-bullet="' + index + '" aria-label="' + (index + 1) + ' / ' + total + ' コンテンツ">' +
							'<circle cx="7" cy="7" r="6.5" class="contents-progress-bg" />' +
							'<circle cx="7" cy="7" r="6.5" class="contents-progress-fill" />' +
							'</svg>' +
							'<div class="contents-progress-dot" aria-hidden="true"></div>' +
							'</button>';
					}
				},
				breakpoints: {
				},
				on: {
					init: function (sw) {
						alignFirst(sw);
						// SVGプログレスアニメーション初期化
						setTimeout(function () {
							updateContentsProgressPagination(0);
						}, 100);
					},
					slideChange: function (sw) {
						// アクティブなスライドインデックスでSVGプログレス更新
						var realIndex = sw.realIndex || 0;
						updateContentsProgressPagination(realIndex);
					}
				}
			});
			// 初期で1枚目が中央に来る (centeredSlides + loop でOK だが 念のため)
			function alignFirst(sw) {
				if (typeof sw.slideToLoop === 'function') {
					sw.slideToLoop(0, 0, false);
				} else {
					// v8 フォールバック: loop前提で最初の実スライド位置へ
					sw.slideTo(0, 0, false);
				}
			}
			// Contents スライダー用SVGプログレスアニメーション更新関数
			function updateContentsProgressPagination(activeIndex) {
				const bullets = document.querySelectorAll('.p-contents-pagination .contents-progress-bullet');
				bullets.forEach(function (bullet, index) {
					const fill = bullet.querySelector('.contents-progress-fill');
					if (!fill) return;
					const isActive = index === activeIndex;
					if (isActive) {
						// 5.5秒のアニメーション（商品スライダーと同じ: delay 4.5s + speed 1s = 5.5s）
						fill.style.animation = 'contentsProgressGauge 5.5s linear forwards';
						fill.setAttribute('aria-hidden', 'false');
						bullet.setAttribute('aria-current', 'true');
					} else {
						fill.style.strokeDashoffset = '40.84';
						fill.style.animation = 'none';
						bullet.removeAttribute('aria-current');
					}
				});
			}
			// キーボードフォーカス対応とSVGプログレスボタンクリック
			contentsSwiper.on('init', function (sw) {
				sw.slides.forEach(function (slide) {
					slide.setAttribute('tabindex', '0');
					slide.addEventListener('focus', function () {
						var idx = Array.prototype.indexOf.call(sw.slides, slide);
						if (idx > -1) sw.slideTo(idx);
					});
				});
				// SVGプログレスボタン個別クリックイベント
				setTimeout(function () {
					var progressBullets = document.querySelectorAll('.p-contents-pagination .contents-progress-bullet');
					progressBullets.forEach(function (bullet, index) {
						bullet.addEventListener('click', function (e) {
							e.preventDefault();
							var bulletIndex = parseInt(bullet.getAttribute('data-contents-bullet'));
							if (!isNaN(bulletIndex)) {
								if (typeof sw.slideToLoop === 'function') {
									sw.slideToLoop(bulletIndex);
								} else {
									sw.slideTo(bulletIndex);
								}
								updateContentsProgressPagination(bulletIndex);
							}
						});
					});
				}, 200);
			});
		})();
	};

	// ================= Products Tabs =================
	const initProductsTabs = () => {
		(function () {
			var tablist = document.querySelector('.p-products-tabs');
			if (!tablist) return;
			var tabs = Array.from(tablist.querySelectorAll('.p-products-tab'));
			var productsLink = document.querySelector('.js-products-link a');
			var productsLinkSpan = productsLink ? productsLink.querySelector('span') : null;

			// 現在のURLから言語を判定（ja or en）
			function getCurrentLanguage() {
				var path = window.location.pathname;
				if (path.includes('/ja/')) return 'ja';
				if (path.includes('/en/')) return 'en';
				// デフォルトはファイルパスから判定
				return 'ja'; // このファイルは ja フォルダにあるため
			}

			function updateProductsLink(tab) {
				if (!productsLink || !productsLinkSpan) return;
				
				var tabText = tab.textContent.trim(); // タブボタンのテキスト（Classic, Contemporary など）
				var tabValue = tab.getAttribute('data-products-tab'); // データ属性値（classic, contemporary など）
				var language = getCurrentLanguage();
				
				// 現在のURLからブランドを判定
				var path = window.location.pathname;
				var brand = 'orient'; // デフォルト
				if (path.includes('/orientstar/')) {
					brand = 'orientstar';
				} else if (path.includes('/orient/')) {
					brand = 'orient';
				}
				
				// リンクテキストを更新
				productsLinkSpan.textContent = tabText;
				
				// hrefを更新
				var newHref = '/' + language + '/' + brand + '/collection/' + tabValue.toLowerCase() + '/';
				productsLink.setAttribute('href', newHref);
			}

			function activate(tab) {
				// 無効化されているタブはアクティブにしない
				if (tab.classList.contains('is-disabled') || tab.getAttribute('aria-disabled') === 'true') {
					// console.log('このタブは無効化されています');
					return;
				}
				
				tabs.forEach(function (t) {
					var active = (t === tab);
					t.classList.toggle('is-active', active);
					t.setAttribute('aria-selected', active ? 'true' : 'false');
					t.tabIndex = active ? 0 : -1;
				});
				
				// js-products-linkを更新
				updateProductsLink(tab);
				
				// タブに対応するスライドへ移動
				slideToCategory(tab);
			}
			
			// タブのカテゴリーに対応するスライドへ移動
			function slideToCategory(tab) {
				// console.log('=== slideToCategory 開始 ===');
				
				var tabValue = tab.getAttribute('data-products-tab'); // classic, contemporary など
				// console.log('タブの data-products-tab:', tabValue);
				
				if (!tabValue) {
					// console.log('エラー: data-products-tab が見つかりません');
					return;
				}
				
				// グローバルに公開されているSwiperインスタンスを取得
				var swiper = window.__prodSwiper;
				// console.log('Swiperインスタンス:', swiper);
				
				if (!swiper) {
					// console.log('エラー: Swiperインスタンスが見つかりません');
					return;
				}
				
				// タブ値を大文字変換（Contemporaryなど）
				var categoryName = tabValue.charAt(0).toUpperCase() + tabValue.slice(1).toLowerCase();
				// console.log('検索するカテゴリー名:', categoryName);
				// console.log('総スライド数:', swiper.slides.length);
				// console.log('現在のアクティブインデックス:', swiper.activeIndex);
				
				// data-petnameが一致するすべてのスライドを収集（クローン含む）
				var matchingSlides = [];
				
				swiper.slides.forEach(function(slide, index) {
					var petname = slide.getAttribute('data-petname');
					var isClone = slide.getAttribute('data-clone') === 'true';
					var origIndex = slide.getAttribute('data-orig-index');
					
					// デバッグ: 各スライドの情報を出力（最初の10個のみ）
					if (index < 10) {
						// console.log('スライド[' + index + ']: petname="' + petname + '", isClone=' + isClone + ', origIndex=' + origIndex);
					}
					
					if (petname && petname.toLowerCase() === categoryName.toLowerCase()) {
						matchingSlides.push({
							index: index,
							petname: petname,
							isClone: isClone,
							origIndex: origIndex
						});
						// console.log('✓ マッチング: スライド[' + index + ']: petname="' + petname + '", isClone=' + isClone);
					}
				});
				
				if (matchingSlides.length === 0) {
					// console.log('カテゴリー "' + categoryName + '" のスライドが見つかりません');
					// console.log('利用可能なカテゴリー（最初の10スライド）:');
					for (var i = 0; i < Math.min(10, swiper.slides.length); i++) {
						// console.log('  - ' + swiper.slides[i].getAttribute('data-petname'));
					}
					return;
				}
				
				// console.log('マッチしたスライド数:', matchingSlides.length);
				
				// カテゴリーの最初のスライド（data-orig-indexが最小）を探す
				// クローンを除外して、オリジナルの最初を見つける
				var originalSlides = matchingSlides.filter(function(slide) {
					return !slide.isClone || slide.isClone === false || slide.isClone === 'false';
				});
				
				// console.log('オリジナルスライド数:', originalSlides.length);
				
				if (originalSlides.length === 0) {
					// console.log('オリジナルスライドが見つからないため、クローンも含めて探索');
					originalSlides = matchingSlides;
				}
				
				// data-orig-indexが最小のスライドを見つける（カテゴリーの最初）
				var firstCategorySlide = originalSlides[0];
				originalSlides.forEach(function(slide) {
					var currentOrigIndex = parseInt(slide.origIndex);
					var firstOrigIndex = parseInt(firstCategorySlide.origIndex);
					if (!isNaN(currentOrigIndex) && !isNaN(firstOrigIndex) && currentOrigIndex < firstOrigIndex) {
						firstCategorySlide = slide;
					}
				});
				
				// console.log('カテゴリーの最初のスライド: index=' + firstCategorySlide.index + ', origIndex=' + firstCategorySlide.origIndex);
				
				// 現在位置から、このカテゴリー最初のスライドへの最短経路を計算（ループ考慮）
				var currentIndex = swiper.activeIndex;
				var totalSlides = swiper.slides.length;
				
				// console.log('現在位置: ' + currentIndex + ', 総スライド数: ' + totalSlides);
				// console.log('--- 全候補の距離計算 ---');
				
				// 同じdata-orig-indexを持つ全スライド（クローン含む）から最短距離を計算
				var bestSlide = null;
				var minDistance = Infinity;
				
				matchingSlides.forEach(function(slide) {
					// 同じdata-orig-indexを持つスライドを探す
					if (slide.origIndex === firstCategorySlide.origIndex) {
						var distanceRight;
						
						// 右方向の距離を計算
						if (slide.index === currentIndex) {
							// 現在位置と同じ（距離0）
							distanceRight = 0;
							
						} else if (slide.index > currentIndex) {
							// 現在位置より右側にある（直接右方向）
							distanceRight = slide.index - currentIndex;
							
						} else {
							// 現在位置より左側にある（ループ経由で右方向）
							distanceRight = (totalSlides - currentIndex) + slide.index;
						}
						
						if (distanceRight < minDistance) {
							minDistance = distanceRight;
							bestSlide = slide;
						}
					}
				});
				
				if (!bestSlide) {
					bestSlide = firstCategorySlide;
					// console.log('フォールバック: カテゴリー最初のスライドを直接使用 [' + bestSlide.index + ']');
				}
				
				// console.log('--- 最終決定 ---');
				// console.log('移動先: index ' + bestSlide.index + ', 距離: ' + minDistance + 'スライド (現在: ' + currentIndex + ')');
				swiper.slideTo(bestSlide.index);
				// console.log('✓ カテゴリー "' + categoryName + '" の最初のスライド (swiper-index: ' + bestSlide.index + ') へ→方向移動完了');
				// console.log('=== slideToCategory 終了 ===\n');
			}
			tabs.forEach(function (tab) {
				tab.addEventListener('click', function () { 
					// 無効化されているタブはクリック不可
					if (tab.classList.contains('is-disabled')) return;
					activate(tab); 
				});
				tab.addEventListener('keydown', function (e) {
					// 無効化されているタブはキーボード操作不可
					if (tab.classList.contains('is-disabled')) return;
					
					var idx = tabs.indexOf(tab);
					var nextTab = null;
					
					if (e.key === 'ArrowRight') { 
						e.preventDefault(); 
						// 次の有効なタブを探す
						for (var i = 1; i <= tabs.length; i++) {
							nextTab = tabs[(idx + i) % tabs.length];
							if (!nextTab.classList.contains('is-disabled')) break;
						}
						if (nextTab && !nextTab.classList.contains('is-disabled')) {
							nextTab.focus(); 
							activate(nextTab);
						}
					}
					else if (e.key === 'ArrowLeft') { 
						e.preventDefault(); 
						// 前の有効なタブを探す
						for (var i = 1; i <= tabs.length; i++) {
							nextTab = tabs[(idx - i + tabs.length) % tabs.length];
							if (!nextTab.classList.contains('is-disabled')) break;
						}
						if (nextTab && !nextTab.classList.contains('is-disabled')) {
							nextTab.focus(); 
							activate(nextTab);
						}
					}
					else if (e.key === 'Home') { 
						e.preventDefault(); 
						// 最初の有効なタブを探す
						for (var i = 0; i < tabs.length; i++) {
							if (!tabs[i].classList.contains('is-disabled')) {
								tabs[i].focus(); 
								activate(tabs[i]);
								break;
							}
						}
					}
					else if (e.key === 'End') { 
						e.preventDefault(); 
						// 最後の有効なタブを探す
						for (var i = tabs.length - 1; i >= 0; i--) {
							if (!tabs[i].classList.contains('is-disabled')) {
								tabs[i].focus(); 
								activate(tabs[i]);
								break;
							}
						}
					}
					else if (e.key === 'Enter' || e.key === ' ') { 
						e.preventDefault(); 
						activate(tab); 
					}
				});
			});

			// 初期化時にアクティブなタブに基づいてリンクを設定
			var activeTab = tablist.querySelector('.p-products-tab.is-active');
			if (activeTab) {
				updateProductsLink(activeTab);
			}
		})();
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		// console.log("Top Page FUNCTIONS Loaded");
		
		// タブ機能は先に初期化
		initProductsTabs();
		
		// スライドDOM生成後にスライダー初期化
		loadProductsData(function() {
			// console.log('スライド生成完了、Swiperを初期化します');
			initProductsSlider();
		});
		
		// コンテンツスライダーを初期化
		initContentsSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
